import React from "react";
import { useParams } from "react-router";
import { LiturgyViewer } from "../liturgy/LiturgyViewer";
import { PointedText } from "../models";
import { useDataDependency } from "../utils/RemoteDataProvider";
import { TweakProvider } from "../utils/TweakProvider";
import { getTenebraeLiturgy } from "./tenebrae";

export type TenebraeResponse = {
    psalms: Record<
        string,
        {
            ant: { gabc: string; tone: string };
            psalm: PointedText;
            tone: string;
        }
    >;
};

export const TenebraePage: React.FC<{}> = () => {
    const { day } = useParams<{
        day: "thursday" | "friday" | "saturday";
    }>();

    const response = useDataDependency<TenebraeResponse>({
        type: "tenebrae",
        day,
    });

    console.log(response);

    if (response.state === "loaded") {
        return (
            <TweakProvider initialState={{}}>
                <div
                    style={{
                        textAlign: "center",
                        padding: 24,
                        paddingTop: 64,
                    }}
                >
                    <div
                        style={{
                            fontSize: "120%",
                            fontWeight: "bold",
                            lineHeight: 1.2,
                        }}
                    >
                        Tenebrae of
                    </div>
                    <div
                        style={{
                            fontSize: "150%",
                            fontWeight: "bold",
                            lineHeight: 1.2,
                        }}
                    >
                        {day === "thursday"
                            ? "Maundy Thursday"
                            : day === "friday"
                            ? "Good Friday"
                            : "Holy Saturday"}
                    </div>
                </div>
                <LiturgyViewer
                    items={getTenebraeLiturgy(day, response.value)}
                />
            </TweakProvider>
        );
    } else {
        return <div>Loading...</div>;
    }
};
